import { Component, OnInit } from '@angular/core';
import { TableMode } from 'src/app/components/grid/grid.component';
import { FieldDataType } from 'src/app/components/grid/FieldDataType';
import { QueryOperand } from 'src/app/components/grid/QueryOperand';
import { ITableData } from 'src/app/components/grid/ITableData';
import { IColumn } from 'src/app/components/grid/IColumn';
import { GridUtil } from 'src/app/components/grid/GridUtil';
import { ExamOperationService } from 'src/app/exam-layout/operations/exam-operation.service';
import { IFileDownload } from 'src/app/interface/dto';
import { EventService } from 'src/app/services/event-services/error-event.service';
import { ExamScheduleService } from 'src/app/services/exam-schedule-service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { AddScheduleFlagsComponent } from '../add-schedule-flags/add-schedule-flags.component';

@Component({
  selector: 'app-exam-schedule-flags',
  templateUrl: './exam-schedule-flags.component.html',
  styleUrls: ['./exam-schedule-flags.component.scss']
})
export class ExamScheduleFlagsComponent implements OnInit {

  gridName = 'examScheduleFlagsGrid';
  constructor(private examSchService: ExamScheduleService, private snackBar: SnackbarService, private eventService: EventService) {

  }

  async ngOnInit() {
    GridUtil.setClearGridSelection();
    this.refreshData();
    this.examSchService.reloadGrid.subscribe((value) => {
      this.refreshData();
    });
  }
  data: ITableData = {
    tableRows: [],
    tableParams: {
      filterParams: [],
      sortParam: {
        fieldName: "",
        orderDirection: 0,
      },
      pageInfo: {
        previousPageSize: 50,
        page: 1,
        pageSize: 50,
        recordCount: 0,
        pageCount: 0
      },
      tableMode: TableMode.serverProcessing,
      selectAll: false
    }
  };

  columns: IColumn[] = [
    {
      displayName: 'Exam Schedule ID',
      fieldName: 'examinationScheduleID',
      fieldDataType: FieldDataType.number,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Attempt',
      fieldName: 'attempt',
      fieldDataType: FieldDataType.number,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Flagged Comment',
      fieldName: 'flaggedComment',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Flagged By',
      fieldName: 'flaggedBy',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Flagged Date/Time',
      fieldName: 'flagDateTime',
      fieldDataType: FieldDataType.dateTime,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'UnFlag',
      fieldName: 'unFlag',
      fieldDataType: FieldDataType.boolean,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'UnFlagged BY',
      fieldName: 'unFlaggedBy',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Review Comments',
      fieldName: 'reviewComments',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'AI Flagged',
      fieldName: 'aiFlagged',
      fieldDataType: FieldDataType.boolean,
      searchable: true,
      orderable: true,

    }
  ];

  onRowClick(idx: any) {
    if (!this.data?.tableRows) { //Just in case tableRows might still not be ready
      setTimeout(() => this.onRowClick(idx), 50);
      return;
    }
    let storedIds = GridUtil.getSelectedDataID(this.gridName) ?? [];
    const selectedScheduleFlag: any[] = idx.map(x => this.data.tableRows[x]).filter(Boolean);
    let selectedDataRowsId = storedIds.length > 0 ? storedIds : selectedScheduleFlag.map(x => x.id);
    GridUtil.setRowCliclk(this.gridName, idx, selectedDataRowsId);
  }

  async refreshData() {
    let newFilter = [{
      fieldName: 'examinationScheduleID',
      fieldValue: `${this.examSchService.selectedSchedules[0].id}`,
      queryOperand: QueryOperand['=='],
      static: true
    }, {
      fieldName: 'attempt',
      fieldValue: `${this.examSchService.selectedSchedules[0].attempt}`,
      queryOperand: QueryOperand['=='],
      static: true
    }];
    this.data.tableParams.filterParams.push(...newFilter);
    const res = await this.examSchService.getExaminationSchedulesFlags(this.data.tableParams) as any[];
    if (!res || res.length === 0) {
      return;
    }
    this.data.tableRows = [];
    const tableParams = { ...this.data.tableParams, pageInfo: res[0].pageInfo };
    this.data.tableParams = tableParams;
    this.data.tableRows = res.slice(1, res.length);
    setTimeout(() => {
      this.eventService.gridDataLoadedEvent.next(true);
    });
  }

  async exportFlagsClicked() {
    const res = await this.examSchService.getExaminationSchedulesFlags(this.data.tableParams).then((res: IFileDownload) => {

      const link = document.createElement('a');
      link.setAttribute('target', '_blank');
      link.setAttribute('href', '' + 'data:application/octet-stream;base64,' + res.file);
      link.setAttribute('download', res.fileName + '.' + res.extension);
      document.body.appendChild(link);
      link.click();
      this.snackBar.success("Flags Exported successfully");
      link.remove();
    });
  }
}
